module.exports = __webpack_public_path__ + "img/CSLHSC-6.9e3fb779.png";